/** @jsx jsx */
import { jsx } from "frontend/src/utils/jsx"
import { LogoSection } from "./LogoSection"
import { CMSLink } from "frontend/src/components/CMSLink"
import { SectionGrid } from "frontend/src/components/Layout"
import Img from "gatsby-image"
import { getFluidHeightFromAsset } from "frontend/src/utils/gatsbyImageHelpers"

function HeroAboveTheFold({ title, text, button, sticker, background, mobile, logos, color }) {
  const [first, second, ...rest] = title.split(" ")
  const firstPart = [first, second].join(" ")
  const secondPart = rest.join(" ")
  return (
    <SectionGrid sx={{ display: ["grid", "grid", "grid"] }}>
      <SectionGrid.wide
        sx={{
          gridRow: "1 / span 1",
          zIndex: "2",
          display: "grid",
          color: color.selected,
          height: ["700px", "800px"],
        }}
      >
        <div
          sx={{
            alignSelf: ["end", "end", "center"],
            mx: 5,

            display: "grid",
          }}
        >
          <div sx={{ alignSelf: ["end", "end", "center"] }}>
            <h2 sx={{ variant: "text.h1" }}>
              {firstPart}
              <br />
              {secondPart}
            </h2>
            <p sx={{ variant: "text.subtitle1", my: 8, maxWidth: ["300px", "400px", "500px"] }}>
              {text}
            </p>
            <CMSLink
              sx={{
                variant: "button.outlined",
                mb: [4, 12],
                color: color.selected,
                borderColor: color.selected,
              }}
              link={button}
            />
          </div>
        </div>
        <LogoSection logos={logos} />
        <Img
          sx={{
            gridColumn: ["1 / span 1", "1 / span 1", "2 / span 2"],
            gridRow: "1 / span 1",
            width: ["100px", "150px", "200px"],
            height: ["100px", "150px", "200px"],
            alignSelf: "center",
            justifySelf: "center",
            ml: [0, 12, 0],
            mr: [18, 0, 5],
          }}
          fluid={getFluidHeightFromAsset(sticker, 200)}
        />
      </SectionGrid.wide>
      <Img
        sx={{
          gridColumn: "1 / span 5",
          gridRow: "1 / span 1",
          height: "800px",
          display: ["none", "none", "block"],
        }}
        fluid={getFluidHeightFromAsset(background, 1300)}
      />
      <Img
        sx={{
          gridColumn: "1 / span 5",
          gridRow: "1 / span 1",
          height: ["700px", "800px"],
          display: ["block", "block", "none"],
        }}
        fluid={getFluidHeightFromAsset(mobile, 1300)}
      />
    </SectionGrid>
  )
}

export { HeroAboveTheFold }
